const ARTSAI_BASE_URL = 'https://arttrk.com/pixel/';

export const buildArtsAiPixelUrl = ({
  action,
  pixelId,
  value,
  orderId,
  contentId,
}) => {
  const params = [
    `ad_log=${encodeURIComponent('referer')}`,
    `action=${encodeURIComponent(String(action || ''))}`,
  ];

  if (value !== undefined && value !== null && value !== '') {
    params.push(`value=${encodeURIComponent(String(value))}`);
  }

  if (orderId !== undefined && orderId !== null && orderId !== '') {
    params.push(`order_id=${encodeURIComponent(String(orderId))}`);
  }

  if (contentId !== undefined && contentId !== null && contentId !== '') {
    params.push(`content_id=${encodeURIComponent(String(contentId))}`);
  }

  params.push(`pixid=${encodeURIComponent(String(pixelId || ''))}`);

  return `${ARTSAI_BASE_URL}?${params.join('&')}`;
};

export const getDiscountCodeFromApplications = (discountApplications = []) => (
  Array.isArray(discountApplications)
    ? discountApplications
      .filter((discount) => discount?.type === 'DISCOUNT_CODE')
      .map((discount) => discount?.title)
      .filter(Boolean)
      .join(', ')
    : ''
);

export const buildMagellanPurchaseMetadata = (itemType, options = {}) => {
  const normalizedItemType = String(itemType || '');
  const metadata = {
    item_type: normalizedItemType,
  };

  if (normalizedItemType === 'membership') {
    metadata.discountCode = String(options?.discountCode || '');
    metadata.lineItems = [{ productType: 'Membership' }];
  }

  return metadata;
};
